import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSafetyHelmetMine1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "safety-helmet-mine-1" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M7.5,6.079a9,9,0,0,0-4.5,7.8v1.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.5,6.079a9,9,0,0,1,4.5,7.8v1.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 7.5,
			y1: 4.125,
			x2: 7.5,
			y2: 10.875
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 16.5,
			y1: 4.125,
			x2: 16.5,
			y2: 10.875
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M13.5,9.375a1.5,1.5,0,0,1-3,0v-6h3Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .75,
			y1: 15.375,
			x2: 23.25,
			y2: 15.375
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M3.75,18.375a2.774,2.774,0,0,1,1.5,2.25h13.5a2.774,2.774,0,0,1,1.5-2.25"
		})
	]
});
export default SvgSafetyHelmetMine1;
